import { render, staticRenderFns } from "./view-info.vue?vue&type=template&id=115f6c00&scoped=true&"
import script from "./view-info.vue?vue&type=script&lang=js&"
export * from "./view-info.vue?vue&type=script&lang=js&"
import style0 from "./view-info.vue?vue&type=style&index=0&id=115f6c00&lang=scss&scoped=true&"
import style1 from "./view-info.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f6c00",
  null
  
)

export default component.exports